import { useState, useEffect } from 'react';

export function useMicrophonePermission() {
  const [hasPermission, setHasPermission] = useState<boolean | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        const result = await navigator.permissions.query({ name: 'microphone' as PermissionName });
        setHasPermission(result.state === 'granted');
        
        result.addEventListener('change', () => {
          setHasPermission(result.state === 'granted');
        });

        return () => {
          result.removeEventListener('change', () => {
            setHasPermission(result.state === 'granted');
          });
        };
      } catch (err) {
        setError('Unable to check microphone permission');
        setHasPermission(false);
      }
    };

    checkPermission();
  }, []);

  const requestPermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach(track => track.stop());
      setHasPermission(true);
      setError(null);
      return true;
    } catch (err: any) {
      setError(err.message || 'Permission denied');
      setHasPermission(false);
      return false;
    }
  };

  return { hasPermission, error, requestPermission };
}